import { createContext } from 'react';
// Same as default but we need it for StyledPopover
export const containerPadding = 12;
export const PopoverContext = createContext({
    containerPadding,
});
//# sourceMappingURL=context.js.map